import React from "react";
import { Dropdown, Switch, Button, Space } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { LogsSettingsProps } from "../types";
import "./LogsSettings.css";

/**
 * Settings dropdown for log display options
 */
export function LogsSettings({ settings, onChange, hasUniqueLabels }: LogsSettingsProps) {
  const menu = (
    <div className="logs-settings-menu">
      <div className="logs-settings-item">
        <label onClick={() => onChange({ showTimestamp: !settings.showTimestamp })}>Show Timestamp</label>
        <Switch
          size="small"
          checked={settings.showTimestamp}
          onChange={(checked) => onChange({ showTimestamp: checked })}
        />
      </div>

      <div className="logs-settings-item">
        <label onClick={() => onChange({ showLabels: !settings.showLabels })}>Show Labels</label>
        <Switch
          size="small"
          checked={settings.showLabels}
          onChange={(checked) => onChange({ showLabels: checked })}
        />
      </div>

      <div className="logs-settings-divider" />

      <div className="logs-settings-item">
        <label
          onClick={() => !settings.prettifyJSON && onChange({ wrapLines: !settings.wrapLines })}
          className={settings.prettifyJSON ? "logs-settings-label-disabled" : ""}
        >
          Wrap Lines
        </label>
        <Switch
          size="small"
          checked={settings.wrapLines || settings.prettifyJSON}
          onChange={(checked) => onChange({ wrapLines: checked })}
          disabled={settings.prettifyJSON}
        />
      </div>

      <div className="logs-settings-item">
        <label onClick={() => onChange({ prettifyJSON: !settings.prettifyJSON })}>Prettify JSON</label>
        <Switch
          size="small"
          checked={settings.prettifyJSON}
          onChange={(checked) => onChange({ prettifyJSON: checked })}
        />
      </div>

      <div className="logs-settings-divider" />

      <div className="logs-settings-item">
        <span>Sort Order</span>
        <Space.Compact className="logs-settings-sort">
          <Button
            size="small"
            type={settings.orderBy === "desc" ? "primary" : "default"}
            onClick={() => onChange({ orderBy: "desc" })}
            aria-label="Sort newest first"
          >
            Newest
          </Button>
          <Button
            size="small"
            type={settings.orderBy === "asc" ? "primary" : "default"}
            onClick={() => onChange({ orderBy: "asc" })}
            aria-label="Sort oldest first"
          >
            Oldest
          </Button>
        </Space.Compact>
      </div>
    </div>
  );

  return (
    <Dropdown popupRender={() => menu} trigger={["click"]} placement="bottomRight">
      <Button icon={<SettingOutlined />} iconPosition="end">Settings</Button>
    </Dropdown>
  );
}
